<script lang="ts" setup>
import EmptyImage from '~/assets/icons/search/empty-search-result.svg?url'
import ArrowIcon from '~/assets/icons/arrows/arrowLeftWhite.svg?url'

defineProps<{
  page: 'brands' | 'products'
}>()

const router = useRouter()
const route = useRoute()
const goToPreviousPage = () => {
  router.push({path: `/search/${route.params.article}`})
}
</script>

<template>
  <div class="search-result-empty">
    <div class="search-result-empty__container">
      <div class="search-result-empty__image">
        <img :src="EmptyImage" alt="">
      </div>

      <div class="search-result-empty__content">
        <h2 class="search-result-empty__title">
          По запросу <span>«{{ $route.params.id }}»</span> {{ page === 'products' ? 'нет предложений' : `ничего не&nbsp;найдено` }}
        </h2>
        <p class="search-result-empty__txt">
          {{page === 'products' ? 'Вернитесь к предыдущему этапу и выберите другой бренд' : 'Проверьте правильность введенного запроса или измените его'}}
        </p>
        <button
          class="search-result-empty__back btn btn_orange btn_svg"
          @click="goToPreviousPage"
          v-if="page === 'products'"
        >
          <img :src="ArrowIcon" alt="">
          Назад
        </button>
        <NuxtLink
          class="search-result-empty__back btn btn_orange"
          v-else
          to="/"
        >
          На главную
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search-result-empty {
  padding: 28px 0 0;
  @include md-breakpoint {
    padding: 0 20px;
  }

  &__container {
    background-color: $bg_page;
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 40px;
    @include md-breakpoint {
      flex-direction: column;
      gap: 20px;
      align-items: flex-start;
    }
  }

  &__content {
    @include md-breakpoint {
      width: 100%;
    }
  }

  &__title {
    @include font(20px, 24px, 600);
    @include md-breakpoint {
      text-align: center;
    }
    span {
      width: 100%;
      word-break: break-word;
      text-transform: uppercase;
    }
  }

  &__txt {
    margin-top: 12px;
    @include md-breakpoint {
      text-align: center;
    }
  }

  &__image {
    @include md-breakpoint {
      align-self: center;
    }
  }

  &__back {
    margin-top: 28px;
    @include md-breakpoint {
      width: fit-content;
      margin: 28px auto 0;
    }
  }
}
</style>
